import React, { useState } from 'react';
import _ from "i18n";
import { connect } from "react-redux";
import { setEventStatsSearchFilter } from "../../../actions/actions.js";
import { debounce } from 'lodash';

const EventStatsSearchFilter = ({ setEventStatsSearchFilter }) => {

  const [search, setSearch] = useState('');

  const handleSearch = (value) => {
    setSearch(value);
    debounce(setEventStatsSearchFilter(value), 500);
  };

  return (
    <div className={'event-filter-search'}>
      <img src="/img/icons/search.svg" className="event-stats-hr" />
      <input
        value={search}
        placeholder={_("search")}
        onChange={({ target: { value } }) => handleSearch(value)}
      />
    </div>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  setEventStatsSearchFilter,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventStatsSearchFilter);


// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/SearchFilter.js